import "./bootstrap";
import focus from '@alpinejs/focus';
import carousel from './Components/Carousel';

// Livewire v3 gestiona Alpine internamente (lo bundlea en livewire.js).
// NO importar Alpine por separado ni llamar Alpine.start() ya que causaría
// dos instancias de Alpine y errores de @entangle.
// Registrar plugins y componentes via alpine:init para que operen sobre
// la instancia de Alpine que Livewire usa.
document.addEventListener('alpine:init', () => {
    Alpine.plugin(focus);
    Alpine.data('carousel', carousel);
});

// Definir sendTrack y sendIdentify antes de inicializar Alpine
// para evitar errores en x-init que los usan
window.sendTrack = window.sendTrack || function (name, payload) {
    const event = new CustomEvent('segment.track', { bubbles:true, detail: {name: name, payload:payload} });
    window.dispatchEvent(event);
};

window.sendIdentify = window.sendIdentify || function (name, payload) {
    const event = new CustomEvent('segment.identify', { bubbles:true, detail: {name: name, payload:payload} });
    window.dispatchEvent(event);
};

import Splide from "@splidejs/splide";
import { Iodine } from "@kingshott/iodine";
import Datepicker from 'flowbite-datepicker/Datepicker';
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

const iodine = new Iodine();
window.tippy = tippy;
window.Splide = Splide;
Datepicker.locales.es = {
    days: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ],
    monthsShort: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
    ],
    today: "Hoy",
    monthsTitle: "Meses",
    weekStart: 1,
    clear: "Borrar",
    titleFormat: "MM y",
};

window.toDatepicker = function (id, options) {
    const datepickerEl = document.getElementById(id);
    new Datepicker(datepickerEl, options);
};

window.addEventListener("search-autocomplete", (event) => {
    if (typeof Livewire !== 'undefined') {
        Livewire.dispatch("searchUpdate", { data: event.detail });
    }
});

window.addEventListener("refreshSplide", (event) => {
    refreshSplide();
});

window.addEventListener("refreshScroll", () => {
    document.getElementById("cards").scrollTop = 0;
    window.dispatchEvent(new CustomEvent("loadedmap"));
});

window.refreshSplide = function (options) {
    var elms = document.getElementsByClassName("splide");
    for (var i = 0, len = elms.length; i < len; i++) {
        if (elms[i].id.search("splide") == -1) {
            if (options !== undefined) {
                new Splide(elms[i], options).mount();
            } else {
                new Splide(elms[i], {
                    width: "100%",
                    type: "loop",
                    perPage: 1,
                    perMove: 1,
                    keyboard: false,
                    arrows: true,
                }).mount();
            }
        }
    }
};

window.initSplideRecommended = function () {
    var elms = document.getElementsByClassName("splide");
    for (var i = 0, len = elms.length; i < len; i++) {
        if (elms[i].id.search("splide") == -1) {
            new Splide(elms[i], {
                width: "100%",
                arrows: true,
                pagination: false,
                perPage: 3,
                gap: "1.5em",
                breakpoints: {
                    640: {
                        perPage: 2,
                        destroy: false,
                        gap: "1em",
                    },
                },
            }).mount();
        }
    }
};

const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

window.debounce = debounce;

window.dataLayer = window.dataLayer || [];

function gtag(){
    dataLayer.push(arguments);
}

window.addEventListener("sendDataLayerCustomEvent", function (event) {
    window.dataLayerCustomEvent(event.detail.name, event.detail.payload);
});

window.dataLayerCustomEvent = function (customName, payload) {
    gtag('event', customName, payload);
};

window.successUrl = function (customName, path) {
    gtag('event', customName, {
        page_location: import.meta.env.VITE_URL+ path,
        page_path: path,
        page_title: document.title
    });
};

window.pageViewUrl = function (path) {
    gtag('event', 'page_view', {
        page_location: import.meta.env.VITE_URL+ path,
        page_path: path,
        page_title: document.title
    });
}

import { createScopedAnalytics } from '@assetplan/analytics-kit';
import { bootstrapSitioWebAnalytics, bootstrapConsoleAnalytics, bootstrapSessionlessAnalytics, bootstrapFeatureFlags } from './bootstrap-analytics';

const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

const analytics = createScopedAnalytics({
    sitio_web: isProduction ? bootstrapSitioWebAnalytics : bootstrapConsoleAnalytics,
    sessionless: isProduction ? bootstrapSessionlessAnalytics : bootstrapConsoleAnalytics,
})

// Inicializar feature flags también en app.js (no solo new.app.js) para que
// las páginas con layout app/guest (como unit/building) tengan el provider
// real y no el stub que devuelve 'control' siempre.
// Si new.app.js ya inicializó (marca _initialized=true), se salta para
// evitar doble bootstrap y doble ejecución de callbacks en onReady.
if (!window.assetplanFlags?._initialized) {
    const realFlags = bootstrapFeatureFlags(isProduction);
    const queuedCallbacks = window.assetplanFlags?._queue ?? [];
    window.assetplanFlags = realFlags;
    realFlags._initialized = true;
    queuedCallbacks.forEach(cb => realFlags.onReady(cb));
}

// start automatic tracking
analytics.init('sitio_web')

window.assetplanAnalytics = analytics;
